export const NUMERIC_PARAM_KEYS = ['bid', 'tid', 'cid', 'oid', 'rid', 'pid']
